/**
 * Website Templates Limits
 * 
 * Configuration for website template pagination and limits
 */

export const WEBSITES_PER_PAGE = 30;

